// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3dgxk","dragIcon":"SortableItem_dragIcon__zemGt","disabled":"SortableItem_disabled__2mVpv"};